import type { FaireProductEntity } from "../../entity_types/product";

export const p_5s2sv2zzhz: FaireProductEntity = {
  token: "p_5s2sv2zzhz",
  type: "product",
  name: "I Smell Snow Crewneck Sweatshirt - Gilmore Girls Gift",
  brandToken: "b_60aa85z7bz",
  brandName: "Painted Lavender",
  imageUrl:
    "https://cdn.faire.com/fastly/92779cdd039eeb90b2683751ac2ece167cdc4abbe4a0f06c9bd01e00178477cb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/966aacc1e78f66ffbfefd4ee3242ee39fea773779796cac29b424e12a523a68d.jpeg",
  ],
  priceDollars: 31,
  description:
    "A comfy sweatshirt featuring one of Lorelai Gilmore's iconic sayings: \"I Smell Snow\" that will keep you toasty all winter long.  If you're looking for a gift for your favorite Gilmore Girls fan, look no further because they will cherish this cozy crewneck.  \n\nDesigned by Painted Lavender, inspired by the Gilmore Girls series, based in a magical place called Stars Hollow.\n\nClassic heavy blend sweatshirt, 50% cotton, 50% polyester.\n\nUnisex sizing.\n\nCare: Recommended machine wash cold, tumble dry low inside out, or hang to dry.\n",
  tags: [],
  msrpDollars: 62,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:43.821Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
